
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import {bus} from "@/plugins/bus";
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import {IBook} from '@/interfaces/book.interface';
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import PrintCarList from "@/modules/CarList/components/PrintCarList.vue";
  import SelectParks from "@/components/SpecialFilters/SelectParks.vue";
  import {IAppState} from "@/interfaces/app-state.interface";
  import AppCorpsFilter from "@/components/FormControls/AppCorpsFilter.vue";

  @Component({
    components: {
      AppCorpsFilter,
      SelectParks,
      PrintCarList,
    }
  })
  export default class Filters extends Vue {
    $refs: any;
    defaultValues: ICarList.IFilterItems = {
      fltCorpId: null,
      fltCorpName: '',
      fltCarTypes: [],
      fltStr: '',
      fltStatusId: null,
      fltParkId: null,
      date: ['', ''],
    };
    corpsFilterKey = 0;

    get storeState(): IAppState { return this.$store.state; }
    get formModel(): ICarList.IFilterItems { return this.storeState.carList.currentFilters; };
    set formModel(value) { this.$store.commit('carList/setProperty', { name: 'currentFilters', value }); };
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get loadingList() { return this.storeState.carList.loading; }

    get filterEmpty() {
      return !Boolean(this.formModel.fltCorpId) &&
      !Boolean(this.formModel.fltCarTypes && this.formModel.fltCarTypes.length) &&
      !Boolean(this.formModel.fltStatusId) &&
      !Boolean(this.formModel.fltStr) &&
      !Boolean(this.formModel.fltParkId) &&
      !Boolean(this.formModel.date);
    }

    get corps() { return this.storeState.book.books.corps; }
    get filters() { return this.storeState.carList.filters; }
    get carStatuses() { return this.storeState.book.books.carStatuses; }
    get carTypes(): IBook.ParkBookItem[] { return this.storeState.book.books[IBook.BookName.carTypes]; }
    get extModeFlag() { return this.storeState.auth.userAccess.extModeFlag; }
    get parksBook(): IBook.ParkBookItem[] { return this.$store.getters['book/parksBook']; }

    async created() {
      if (!this.extModeFlag && !this.filterEmpty) {
        await this.clearFilters();
      }
    }

    async mounted() {
      this.formModel = { ...this.defaultValues };
      if (this.filters) this.formModel = Object.assign({}, this.defaultValues, this.filters);
      bus.$on(ICarList.EmitterEvents.CLEAR_FILTERS, () => {
        this.clearFilters();
      });

      KeyboardMobileHidden();
      this.corpsFilterKey++;
    }

    async onFilterClick () {
      await this.$store.dispatch('carList/setFilters');
    }

    clearFilters() {
      this.formModel = { ...this.defaultValues };
      this.onFilterClick();
    }

    blurCorp({ event, list }) {
      if (!event.target.value) return;
      let enteredValue = event.target.value.toString();
      let bookItem = list.find(item => item.name.toLowerCase().includes(enteredValue));
      if (bookItem) {
        this.$store.commit('carList/setFilterProp', { name: 'fltCorpId', value: bookItem.id });
      }
    }

    @Watch('filters')
    onFiltersChange() {
      this.formModel = { ...this.filters };
    }

    @Watch('extModeFlag')
    async onExtModeChange() {
      if (!this.extModeFlag && !this.filterEmpty) {
        await this.clearFilters();
      }
    }

    destroyed() {
      bus.$off(ICarList.EmitterEvents.CLEAR_FILTERS);
    }
  }
